
import { computed, defineComponent } from 'vue'

export default defineComponent({
  components: {
  },

  props: {
    platform: {
      type: String,
      default: 'desktop',
    },

    useMap: {
      type: Boolean,
      default: false,
    },
  },

  setup (props) {
    const labelClass = computed(() => props.useMap ? 'label map' : 'label')
    return {
      labelClass,
    }
  },
})
